<template>
    <v-content :style="{'background-image': `url('`+ require('../assets/bg-login.jpg') +`')`}"
               style="background-size: cover">

        <!-- Header -->
        <Header></Header>
        <!-- Menu -->
        <v-layout justify-center>
            <v-flex xs12 style="background-color: #527281">
                <v-content>
                    <v-layout px-12 py-3>
                        <v-flex shrink style="text-align: left;">
                            <v-btn text small style="color: white;font-size: 18px" @click="$router.push('/home').catch(err => {})">
                                หน้าแรก
                            </v-btn>
                        </v-flex>
                        <v-icon style="color: white">play_arrow</v-icon>
                        <v-flex shrink style="text-align: left;">
                            <v-btn text small style="color: white;font-size: 18px">ช่วยเหลือ</v-btn>
                        </v-flex>
                    </v-layout>
                </v-content>
            </v-flex>
        </v-layout>
        <!-- Detail -->
        <v-layout>
            <v-flex class="my-12">
                <v-layout>
                    <v-flex xs7 style="text-align: right" class="offset-2">
                        <span class="" style="font-size: 36px; color: #D97C57;font-weight: bold">ปัญหาที่พบบ่อย?</span>
                    </v-flex>
                    <v-flex xs5 class="offset-1">
                        <v-btn style="background-color: #84A2A8; color: white;border-radius: 25px;" @click="downloadManual">
                            ดาวน์โหลดคู่มือการใช้งาน
                        </v-btn>
                    </v-flex>
                </v-layout>
                <v-layout justify-center>
                    <v-flex xs10 class="py-6" style="background-color: #527281">
                    </v-flex>
                </v-layout>
                <v-layout justify-center>
                    <v-flex xs10>
                        <v-card class="pb-6 pt-4" style="background-color: #ffffff;">
                                <v-layout justify-center>
                                    <v-flex xs11 class="my-4 pa-12" style="background-color: rgba(191, 191, 191, 0.08);border-radius: 20px">
                                        <div style="text-align: left" v-html="html"></div>
                                    </v-flex>
                                </v-layout>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>

        <v-layout>
            <v-flex class="py-6" style="background-color: white">
            </v-flex>
        </v-layout>
        <!-- Footer -->
        <Footer></Footer>
    </v-content>
</template>

<script>
    import Header from "../components/Header";
    import Footer from "../components/Footer";

    export default {
        name: "Help",
        components: {
            Footer,
            Header,
        },
        data: () => ({
            linkManual: null,
            html:'',
        }),
        created() {
            this.getQuestion();
        },
        methods: {
            downloadManual() {
                this.$store.dispatch('Common/getManual').then(res => {
                    window.open(res)
                })
            },
            getQuestion() {
                this.$store.dispatch('Common/getQuestion').then(res => {
                    this.html = res.html;
                })
            }
        }
    }
</script>

<style scoped lang="scss">

</style>
